// removed by extract-text-webpack-plugin
module.exports = {"providerLogo":"ProviderLogo__providerLogo","logo":"ProviderLogo__logo","providerName":"ProviderLogo__providerName","growDotQello":"ProviderLogo__growDotQello","growDotBlue":"ProviderLogo__growDotBlue","growDotGolden":"ProviderLogo__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProviderLogo/ProviderLogo.scss
// module id = 1879
// module chunks = 0